import { useEffect } from "react";
import { getLogoutUrl } from "../authConfig";
import SystemTransition from "../components/SystemTransition";

export default function Logout() {
  useEffect(() => {
    console.log("🔴 Cerrando sesión…");

    // Limpiar tokens
    localStorage.removeItem("idToken");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    // Redirigir a Cognito logout
    window.location.href = getLogoutUrl();
  }, []);

  return <SystemTransition
  mode="logout"
  title="Cerrando sesión"
  subtitle="Protegiendo tu información antes de salir"
 />;
}
